import { SproutIcon, BriefcaseIcon, type LucideIcon } from 'lucide-react';

export type TextSegment = { text: string; strong?: boolean };

export type ProfileList = { title: string; items: { text: string; highlight?: boolean }[]; style: 'checks' | 'chips' };

export type Profile = {
  id: 'start' | 'working';
  cardLabel: string;
  tag: string;
  title: TextSegment[];
  paragraphs: TextSegment[][];
  lists: ProfileList[];
  quote: [string, string];
  footnoteTitle?: string;
  footnote: string;
  icon: LucideIcon;
};

export const profiles: Profile[] = [
  {
    id: 'start',
    cardLabel: 'Quiero empezar',
    tag: 'Si todavía no trabajás con adultos mayores',
    title: [{ text: 'Convertí tus conocimientos en una ' }, { text: 'nueva oportunidad profesional', strong: true }],
    paragraphs: [
      [
        { text: 'Si sos Personal Trainer, profesor/a de Educación Física, instructor/a o trabajás en el ámbito del movimiento, podés incorporar el trabajo con adultos mayores como ' },
        { text: 'una nueva área dentro de tus servicios.', strong: true },
      ],
      [
        { text: 'REACTIVA TU CUERPO te brinda una formación práctica y recursos específicos para que puedas prepararte para trabajar con ' },
        { text: 'personas mayores.', strong: true },
      ],
    ],
    lists: [
      {
        title: '¿Qué vas a lograr?',
        style: 'checks',
        items: [
          { text: 'Incorporar herramientas específicas para trabajar con adultos mayores.', highlight: true },
          { text: 'Aprender a planificar y estructurar sesiones adaptadas.' },
          { text: 'Contar con ejercicios, actividades y rutinas listas para utilizar.', highlight: true },
          { text: 'Ampliar los servicios que podés ofrecer como profesional.' },
          { text: 'Prepararte para desarrollar una nueva área de trabajo.' },
        ],
      },
      {
        title: '¿Dónde podés aplicar estos conocimientos?',
        style: 'chips',
        items: [
          { text: 'Gimnasios' },
          { text: 'Centros de jubilados' },
          { text: 'Geriátricos y residencias' },
          { text: 'Clubes' },
          { text: 'Centros de día' },
          { text: 'Entrenamiento personalizado' },
          { text: 'Espacios de actividad física para adultos mayores' },
        ],
      },
    ],
    quote: ['No necesitás empezar de cero.', 'Sumá una nueva especialización a los conocimientos que ya tenés.'],
    footnote:
      'Accedé al contenido desde el primer día y comenzá a incorporar sus herramientas a tu preparación y práctica profesional.',
    icon: SproutIcon,
  },
  {
    id: 'working',
    cardLabel: 'Ya trabajo con adultos mayores',
    tag: 'Si ya trabajás con adultos mayores',
    title: [
      { text: 'Dejá de buscar ejercicios sueltos y tené ' },
      { text: 'todo organizado en un solo lugar', strong: true },
    ],
    paragraphs: [
      [
        { text: 'Si ya trabajás con personas mayores, probablemente tengas experiencia y conocimientos. Pero eso no significa que tengas que ' },
        { text: 'perder tiempo buscando', strong: true },
        { text: ' constantemente nuevas actividades, ejercicios o ideas para cada sesión.' },
      ],
      [
        { text: 'REACTIVA TU CUERPO reúne en un solo lugar ' },
        { text: 'recursos prácticos', strong: true },
        { text: ' para ayudarte a organizar, variar y enriquecer tu trabajo.' },
      ],
    ],
    lists: [
      {
        title: '¿Qué vas a obtener?',
        style: 'checks',
        items: [
          { text: 'Recursos específicos para planificar tus sesiones.' },
          { text: 'Ejercicios de movilidad, fuerza y equilibrio.' },
          { text: 'Rutinas listas para utilizar y adaptar.', highlight: true },
          { text: 'Actividades para mantener la mente activa.' },
          { text: 'Actividades individuales y grupales.' },
          { text: 'Recursos para trabajar diferentes capacidades físicas.' },
          { text: 'Un calendario de 90 días para organizar tus propuestas.', highlight: true },
        ],
      },
    ],
    quote: ['Menos tiempo buscando qué hacer.', 'Más tiempo enfocado en tus alumnos.'],
    footnoteTitle: '¿Por qué te conviene?',
    footnote:
      'Porque vas a tener una biblioteca de recursos organizada y pensada específicamente para el trabajo con adultos mayores, evitando tener que recurrir constantemente a Google, Instagram o YouTube para encontrar nuevas ideas.',
    icon: BriefcaseIcon,
  },
];
